const OPT_OUT_KEY_PREFIX = "__mp_opt_in_out_"
const OPTED_OUT_VALUE = "0"

export function readMixpanelToken(): string | null {
  const bundle = document.getElementById("app")?.getAttribute("data-bundle")
  if (!bundle) {
    return null
  }

  try {
    const data = JSON.parse(bundle) as {
      mixpanelToken?: string
    }

    return data.mixpanelToken ?? null
  } catch {
    return null
  }
}

// APP-3555: a teardown in useMixPanel used to persist this flag, and the Segment device-mode Mixpanel
// honours it on every page. Clearing the key directly needs no initialized SDK, so it reaches the
// browsers the replay flag leaves out. Remove once production no longer reports the flag.
export function clearStaleMixpanelOptOut(): void {
  const token = readMixpanelToken()
  if (!token) {
    return
  }

  try {
    const key = `${OPT_OUT_KEY_PREFIX}${token}`
    if (localStorage.getItem(key) === OPTED_OUT_VALUE) {
      localStorage.removeItem(key)
    }
  } catch {
    // localStorage access can fail in private browsing
  }
}
